import { IListApiModel } from './api.model';
import { UserType } from './user.model';

export enum RegisterFormActions {
  REGISTER_FORM_INIT = '[Register Form] Init',
  LOAD_REGISTER_FORM = '[Register Form] Load form',
  LOAD_REGISTER_FORM_SUCCESS = '[Register Form] Load Form success',
  VALIDATE_FORM = '[Register Form] Validate Form',
  VALIDATE_FORM_SUCCESS = '[Register Form] Validate Form Success',
  VALIDATE_FORM_ERROR = '[Register Form] Validate Form Error',
  PAY = '[Register Form] Pay',
  PAY_SUCCESS = '[Register Form] Pay Success',
  PAY_ERROR = '[Register Form] Pay Error',
  CONFIRM = '[Register Form] Confirm',
  CONFIRM_SUCCESS = '[Register Form] Confirm Success',
  CONFIRM_ERROR = '[Register Form] Confirm Error',
}

export enum RegisterFormStatus {
  REGISTER_STATE_INITIALIZING,
  REGISTER_STATE_READY,
  REGISTER_FOR_VALIDATING,
  REGISTER_STATE_VALID,
  REGISTER_STATE_INVALID,
  REGISTER_STATE_PAYING,
  REGISTER_STATE_PAY_VALID,
  REGISTER_STATE_PAY_INVALID,
  REGISTER_STATE_CONFIRM,
  REGISTER_STATE_CONFIRM_SUCCESS,
  REGISTER_STATE_CONFIRM_ERROR,
}

export interface RegisterFormState {
  step: number;
  status: RegisterFormStatus;
  confirmation_token?: string;
  errors: any;
  data: RegisterForm;
  payData?: RegisterFormPay;
  paymentReceipt: RegisterReceiptData;
  confirmationToken?: string;
  confirmationError?: string;
  referralRef?: string;
  prefilledDiscount?: string;
  ssoMode?: boolean;
  registrationToken?: string;
}

export interface ISubscriptionItem {
  id: number;
  trial_days: number;
  plan_id: string;
  plan_cost: string;
  credits: number;
  subscription_cost: string;
  additional_user_cost: string;
  additional_user_plan: string;
  team_code: string;
}

export interface ISubscriptionsResult extends IListApiModel {
  items: ISubscriptionItem[];
}

export interface IEmailValidation {
  email_exists: boolean;
}

export interface IStepConfirmValidation {
  success: boolean;
  errors: {
    email?: string[]
  };
}

export interface RegisterFormLoadData {
  step: number;
  confirmation_token?: string;
  account_id?: string;
  data?: RegisterForm;
  forceBilling?: boolean;
  referralRef?: string;
  prefilledDiscount?: string;
}

export interface RegisterFormPay {
  card_name?: string;
  card_number?: string;
  expire_month?: number;
  expire_year?: number;
  card_id?: string;
  team_code?: string;
  discount?: string;
  amount?: string;
  username?: string;
}

export interface PaymentData {
  card_brand: string;
  card_country: string;
  card_exp_month: number;
  card_exp_year: number;
  card_last_4: string;
  card_name: string;
  payment_amount: string;
  payment_biling_details: string[];
  payment_charge: string;
  payment_currency: string;
  payment_date: string;
  payment_description: string;
  payment_processed: boolean;
  payment_receipt: string;
  client_address: string;
  client_email: string;
  client_first_name: string;
  client_last_name: string;
  client_phone: string;
  payment_recurring: string;
  plan_trial: string;
  product_name: string;
  subscription_cost: string;
  subscription_period: string;
  trial_days: number;
  setup_cost: string;
  contacts_limit: number;
  send_limit: number;
  setup_discount_percentage: boolean;
  subscription_discount: string;
  discount_percentage: boolean;
  setup_discount: string;
  discount: string;
  applied_team_code: string;
}

export interface RegisterReceiptData {
  account_id: number;
  payment_data: PaymentData;
  success: boolean;
  errors: string[];
}

export interface RegisterForm {
  user_type: UserType;
  email: string;
  first_name: string;
  last_name: string;
  company: string;
  phone_number: string;
  address1: string;
  address2: string;
  country: string;
  city: string;
  state: string;
  zip: string;
  time_zone: string;
  user_dst_bit: boolean;
  password: string;
  confirm_password: string;
  terms_accepted?: boolean;
  ref?: string;
}

export const STATES = [
  ['Alabama', 'AL'],
  ['Alaska', 'AK'],
  ['Arizona', 'AZ'],
  ['Arkansas', 'AR'],
  ['California', 'CA'],
  ['Colorado', 'CO'],
  ['Connecticut', 'CT'],
  ['Delaware', 'DE'],
  ['District of Columbia', 'DC'],
  ['Florida', 'FL'],
  ['Georgia', 'GA'],
  ['Hawaii', 'HI'],
  ['Idaho', 'ID'],
  ['Illinois', 'IL'],
  ['Indiana', 'IN'],
  ['Iowa', 'IA'],
  ['Kansas', 'KS'],
  ['Kentucky', 'KY'],
  ['Louisiana', 'LA'],
  ['Maine', 'ME'],
  ['Maryland', 'MD'],
  ['Massachusetts', 'MA'],
  ['Michigan', 'MI'],
  ['Minnesota', 'MN'],
  ['Mississippi', 'MS'],
  ['Missouri', 'MO'],
  ['Montana', 'MT'],
  ['Nebraska', 'NE'],
  ['Nevada', 'NV'],
  ['New Hampshire', 'NH'],
  ['New Jersey', 'NJ'],
  ['New Mexico', 'NM'],
  ['New York', 'NY'],
  ['North Carolina', 'NC'],
  ['North Dakota', 'ND'],
  ['Ohio', 'OH'],
  ['Oklahoma', 'OK'],
  ['Oregon', 'OR'],
  ['Pennsylvania', 'PA'],
  ['Puerto Rico', 'PR'],
  ['Rhode Island', 'RI'],
  ['South Carolina', 'SC'],
  ['South Dakota', 'SD'],
  ['Tennessee', 'TN'],
  ['Texas', 'TX'],
  ['Utah', 'UT'],
  ['Vermont', 'VT'],
  ['Virginia', 'VA'],
  ['Washington', 'WA'],
  ['West Virginia', 'WV'],
  ['Wisconsin', 'WI'],
  ['Wyoming', 'WY'],
  ['Alberta', 'AB'],
  ['British Columbia', 'BC'],
  ['Manitoba', 'MB'],
  ['New Brunswick', 'NB'],
  ['Newfoundland and Labrador', 'NL'],
  ['Northwest Territories', 'NT'],
  ['Nova Scotia', 'NS'],
  ['Nunavut', 'NU'],
  ['Ontario', 'ON'],
  ['Prince Edward Island', 'PE'],
  ['Quebec', 'QC'],
  ['Saskatchewan', 'SK'],
  ['Yukon', 'YT'],
  ['Atlanta', 'Atlanta'],
  ['Baltimore', 'Baltimore'],
  ['Washington', 'Washington'],
  ['Boston', 'Boston'],
  ['Chicago', 'Chicago'],
  ['Cleveland', 'Cleveland'],
  ['Dallas', 'Dallas'],
  ['Denver', 'Denver'],
  ['Detroit', 'Detroit'],
  ['Houston', 'Houston'],
  ['Los Angeles', 'Los Angeles'],
  ['Miami', 'Miami'],
  ['Minneapolis', 'Minneapolis'],
  ['St. Paul', 'St. Paul'],
  ['New York', 'New York'],
  ['Philadelphia', 'Philadelphia'],
  ['Phoenix', 'Phoenix'],
  ['Portland', 'Portland'],
  ['Saint Louis', 'Saint Louis'],
  ['Salt Lake City', 'Salt Lake City'],
  ['San Diego', 'San Diego'],
  ['San Francisco', 'San Francisco'],
  ['Seattle', 'Seattle'],
  ['Calgary', 'Calgary'],
  ['Edmonton', 'Edmonton'],
  ['Montreal', 'Montreal'],
  ['Ottawa', 'Ottawa'],
  ['Quebec', 'Quebec'],
  ['Toronto', 'Toronto'],
  ['Vancouver', 'Vancouver'],
  ['Victoria', 'Victoria'],
  ['Winnipeg', 'Winnipeg'],
];
